export default __webpack_public_path__ + "static/media/email.6f81e76a.svg";